"use client";

import { ActionForm } from "@/components/forms/ActionForm";
import { projectAction } from "@/features/projects/server/actions";

export type PlazaCastingContext = {
  favorites: string[];
  project?: { id: string; version: number; archived: boolean; roleId: string; avatarId?: string | null; authorizationId?: string | null };
};

export function PlazaCastingActions({ avatarId, context }: { avatarId: string; context: PlazaCastingContext }) {
  const project = context.project;
  if (!project) return null;
  const selected = project.avatarId === avatarId;
  return <div className="flex flex-wrap items-center gap-3 border-t border-[var(--color-line)] p-3 text-xs sm:p-4">
    <ActionForm action={projectAction}>
      <input type="hidden" name="operation" value="selectAvatar" /><input type="hidden" name="projectId" value={project.id} /><input type="hidden" name="version" value={project.version} /><input type="hidden" name="roleId" value={project.roleId} /><input type="hidden" name="avatarId" value={avatarId} />
      <button className="btn-silver rounded-full px-3 py-2 disabled:opacity-50" disabled={project.archived || Boolean(project.authorizationId) || selected}>{selected ? "已选此形象" : "选为此角色"}</button>
    </ActionForm>
  </div>;
}
